/**
 * <s-signup-popup> — opens the email signup dialog once per visitor after a delay.
 *
 * Attributes:
 *   delay        — seconds before the popup opens (default 10)
 *   storage-key  — localStorage key that remembers the visitor has seen it
 *   suppress     — present in the editor so the popup never auto-opens while editing
 *   posted       — present after a signup or error so the result shows immediately
 */
class SSignupPopup extends HTMLElement {
  #timer = null;
  #ac;

  connectedCallback() {
    const dialog = this.querySelector('dialog');
    if (!dialog) return;

    this.#ac = new AbortController();
    const key = this.getAttribute('storage-key') || 'tbots-signup-popup';

    dialog.addEventListener('close', () => {
      if (!this.hasAttribute('preview')) this.#remember(key);
    }, { signal: this.#ac.signal });

    if (this.hasAttribute('preview')) {
      if (!dialog.open) dialog.showModal();
      return;
    }

    if (this.hasAttribute('posted')) {
      this.#remember(key);
      if (!dialog.open) dialog.showModal();
      return;
    }

    if (this.hasAttribute('suppress') || this.#seen(key)) return;

    const delay = Math.max(0, Number(this.getAttribute('delay')) || 10) * 1000;
    this.#timer = window.setTimeout(() => {
      if (!dialog.open && !document.querySelector('dialog[open]')) dialog.showModal();
    }, delay);
  }

  disconnectedCallback() {
    window.clearTimeout(this.#timer);
    this.#ac?.abort();
  }

  #seen(key) {
    try {
      return window.localStorage.getItem(key) !== null;
    } catch {
      return false;
    }
  }

  #remember(key) {
    try {
      window.localStorage.setItem(key, String(Date.now()));
    } catch {
      /* storage unavailable: popup may show again next visit */
    }
  }
}

customElements.define('s-signup-popup', SSignupPopup);
